import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'
import { compose } from 'redux'

import { getProgramTypeCacheStore } from '../../../../services/partner360/configuration/helpers/getProgramTypeCacheStore'
import { changeProgramType } from '../api/changeProgramType'
import { getAvailableProgramTypes } from '../helpers/getAvailableProgramTypes'
import { partnerDataFulfilled } from '../partnerDataLifecycle'
import { selectFinancialYear } from '../selectors/selectFinancialYear'
import { selectOfferingsMode } from '../selectors/selectOfferingsMode'
import { selectPartnerAccess } from '../selectors/selectPartnerAccess'
import { selectPartnerId } from '../selectors/selectPartnerId'
import { selectProgramType } from '../selectors/selectProgramType'
import { selectProgramTypes } from '../selectors/selectProgramTypes'

listenerMiddleware.startListening({
  actionCreator: partnerDataFulfilled,
  effect: async (action, { getState, dispatch }) => {
    const programTypesWithSummary = compose(selectProgramTypes, getState)()
    const partnerId = compose(selectPartnerId, getState)()
    const fYear = compose(selectFinancialYear, getState)()
    const isNewOfferingsMode = compose(selectOfferingsMode, getState)()
    const { isHybrid } = compose(selectPartnerAccess, getState)()

    const programTypeCache = getProgramTypeCacheStore()
    const cachedProgramType = await programTypeCache.getById(
      isNewOfferingsMode ? `${partnerId}_${fYear}_new` : `${partnerId}_${fYear}_old`
    )

    if (
      cachedProgramType &&
      programTypesWithSummary.some((it) => it.programType === cachedProgramType.programType)
    ) {
      dispatch(changeProgramType(cachedProgramType.programType))
      return
    }

    const availableProgramTypes = getAvailableProgramTypes(programTypesWithSummary, {
      isNewOfferingsMode,
      isHybridPartner: isHybrid,
    }).filter((it) => it.enabled)

    const currentProgramType = compose(selectProgramType, getState)()
    if (availableProgramTypes.every((it) => it.programType !== currentProgramType)) {
      dispatch(changeProgramType(availableProgramTypes[0].programType))
      return
    }

    dispatch(changeProgramType(currentProgramType))
  },
})
